<template>
  <div class="ai-assistant-wrapper">
    <div class="ai-assistant__header">
      <div class="ai-assistant__title-area">
        <h3 class="ai-assistant__title">AI老师助手</h3>
      </div>
      <div class="ai-assistant__actions">
        <button class="ai-assistant__close-btn" @click="handleClose">
          <img src="/images/close.svg" alt="关闭" />
        </button>
      </div>
    </div>

    <div class="ai-assistant__content" ref="chatContent">
      <!-- 对话消息列表 -->
      <div
        v-for="(message, index) in messages"
        :key="index"
        :class="[
          'message',
          message.type === 'user' ? 'user-message' : 'ai-message',
        ]"
      >
        <div class="message-avatar" v-if="message.type === 'ai'">
          <img :src="aiIconUrl" alt="AI" />
        </div>
        <div class="message-content">
          <div
            :class="[
              'message-bubble',
              message.type === 'user' ? 'user-bubble' : 'ai-bubble',
            ]"
          >
            <div v-if="message.type === 'user'" class="user-text">
              {{ message.content }}
            </div>
            <div
              v-else
              :class="message.isWelcome ? '' : 'ai-text'"
              v-html="
                message.isWelcome
                  ? message.content
                  : formatMessage(message.content)
              "
            ></div>
            <div
              v-if="message.type === 'ai' && !message.isWelcome"
              class="chat-action-copy"
              @click="copyReplyText(message.content)"
            >
              <img class="chat-action-img" :src="copyIconUrl" />
              <span>复制</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 正在输入状态 -->
      <div v-if="isLoading && !isSubmit" class="message ai-message">
        <div class="message-avatar">
          <img :src="aiIconUrl" alt="AI" />
        </div>
        <div class="message-content">
          <div class="message-bubble ai-bubble">
            <div class="typing-indicator">AI正在思考中...</div>
          </div>
        </div>
      </div>

      <!-- 回到底部按钮 -->
      <!-- <div
        v-if="isUserScrolling"
        class="scroll-to-bottom-btn"
        @click="scrollToBottomForced"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7,10L12,15L17,10H7Z" />
        </svg>
        <span>回到底部</span>
      </div> -->
    </div>

    <div class="ai-assistant__footer">
      <div class="input-area">
        <div class="input-container">
          <textarea
            v-model="inputText"
            :placeholder="isSubmit ? 'AI正在生成中...' : '发消息...'"
            class="message-input"
            @keydown.enter.prevent="handleSendMessage"
            :disabled="isLoading || isSubmit"
            rows="1"
            ref="messageInput"
          ></textarea>
          <button
            @click="handleSendMessage"
            :disabled="!inputText.trim() || isLoading || isSubmit"
            class="send-btn"
          >
            <img src="@/assets/images/laoshibang/send-icon.png" alt="send" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendQuestionStream } from "@/api/chat";
import { getLocalToken } from "@/utils/token";
import sObserver from "@/utils/simpleObserver";
import { copyToClipboard } from "@/utils/utils";
import { marked } from "marked";
import sensors from "sa-sdk-javascript";
import { getAiassistantInfo } from "@/api/home";

export default {
  name: "AiAssistant",
  data() {
    return {
      aiIconUrl: require("@/assets/images/laoshibang/ai-icon.png"),
      copyIconUrl: require("@/assets/images/laoshibang/copy-icon.png"),
      messages: [
        {
          type: "user",
          content: this.searchContent,
          timestamp: new Date(),
        },
        {
          type: "ai",
          content: "",
          timestamp: new Date(),
          isWelcome: true,
        },
      ],
      inputText: "",
      isLoading: false,
      currentStream: null,
      hasInitialized: false, // 添加初始化状态标记
      prologueDesc: "",
      aiConfig: "",
      isUserScrolling: false, // 用户是否在手动滚动
      scrollTimer: null, // 滚动定时器
      isSubmit: false,
    };
  },
  props: {
    searchContent: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedTitle() {
      return this.title || "AI老师助手";
    },
    isNotLogin() {
      return !getLocalToken("tal_token");
    },
  },
  async mounted() {
    await this.getDeepThinkConfig();
    this.autoResizeTextarea();
    this.addScrollListener(); // 添加滚动监听器
    if (this.searchContent && !this.hasInitialized) {
      // 开始AI回复
      this.sendToAI(this.searchContent);
      this.hasInitialized = true;
    } else {
      this.messages = [
        {
          type: "ai",
          content: this.prologueDesc,
          timestamp: new Date(),
          isWelcome: true,
        },
      ];
    }
    sensors.track("home_search_result_assist_show");
  },
  beforeDestroy() {
    // 组件销毁时关闭流式连接
    if (this.currentStream && this.currentStream.isActive) {
      this.currentStream.close();
    }
    this.removeScrollListener(); // 移除滚动监听器
  },
  activated() {
    this.addScrollListener(); // 添加滚动监听器
    if (this.searchContent && !this.hasInitialized) {
      // 开始AI回复
      this.sendToAI(this.searchContent);
      this.hasInitialized = true;
    }
  },
  inject: ["sendToAiAllready"],
  methods: {
    async getDeepThinkConfig() {
      getAiassistantInfo({ ty: "normal" })
        .then((res) => {
          if (res.code === 200) {
            for (const item in res.data) {
              console.log("item", item, res.data[item]);
              this.prologueDesc = res.data[item]?.prologueDesc;
              if (res.data[item]?.logo) {
                this.aiIconUrl = res.data[item]?.logo;
              }
            }
          }

          // 更新欢迎消息内容
          const welcomeMessage = this.messages.find((msg) => msg.isWelcome);
          if (welcomeMessage) {
            welcomeMessage.content = `<div class="welcome-text">
              <p class="sub-text">${
                this.prologueDesc ||
                "我们暂时没有上线相关应用，让我直接为您解答疑惑吧！"
              }</p>
            </div>`;
          }
        })
        .catch((error) => {
          console.error("获取AI助手配置失败:", error);
          // 设置默认欢迎消息
          const welcomeMessage = this.messages.find((msg) => msg.isWelcome);
          if (welcomeMessage) {
            welcomeMessage.content = `<div class="welcome-text">
              <p class="welcome-text-title">你好，我是AI老师助手～</p>
              <p class="sub-text">我们暂时没有上线相关应用，让我直接为您解答疑惑吧！</p>
            </div>`;
          }
        });
    },
    copyReplyText(answerContent) {
      sensors.track("home_search_result_assist_copy_click");
      // 调用复制到剪贴板的函数
      copyToClipboard(answerContent);

      // 弹出提示信息
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    handleClose() {
      // 关闭流式连接
      if (this.currentStream && this.currentStream.isActive) {
        this.currentStream.close();
      }
      this.$emit("close");
    },

    handleSendMessage(from) {
      this.isSubmit = true;
      sensors.track("home_search_result_assist_send_click", {
        content: this.inputText.trim(),
      });
      if (!this.inputText.trim() || this.isLoading) return;

      if (this.isNotLogin) {
        // 阻止默认行为和事件冒泡
        if (event && event.preventDefault) {
          event.preventDefault();
        }
        if (event && event.stopPropagation) {
          event.stopPropagation();
        }
        console.log("没登录，需要登录", this.isNotLogin);
        return sObserver.fire("laoshibang-login");
      }

      // 用户主动发送消息时，重新启用自动滚动
      this.isUserScrolling = false;

      let userMessage = this.inputText.trim();
      this.inputText = "";

      if (from !== "activated") {
        // 添加用户消息
        this.messages.push({
          type: "user",
          content: userMessage,
          timestamp: new Date(),
        });
      } else {
        console.log("activated", this.searchContent);
        userMessage = this.searchContent;
      }

      // 开始AI回复
      this.sendToAI(userMessage);

      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    async sendToAI(question) {
      this.sendToAiAllready();
      // 如果已经在加载中，不重复发送
      if (this.isLoading) {
        console.log("正在处理中，跳过重复请求");
        return;
      }

      // 关闭之前的流式连接
      if (this.currentStream && this.currentStream.isActive) {
        this.currentStream.close();
      }

      this.isLoading = true;

      try {
        // 调用流式API
        this.currentStream = await sendQuestionStream(
          "/v2/aiassistant/question",
          {
            content: question,
            type: "normal",
          },
          // onMessage 回调
          (data) => {
            console.log("收到AI消息:", data);

            // 检查状态，如果是4则表示流式连接已关闭，停止处理
            if (
              data.data &&
              (data.data.status === 4 || data.data.status === 5)
            ) {
              // 添加新的AI消息对象
              this.messages.push({
                type: "ai",
                content: "抱歉，AI助手暂时无法回答您的问题，请稍后再试。",
                timestamp: new Date(),
              });
              console.log("流式连接已关闭，停止处理");
              this.isLoading = false;
              if (this.currentStream && this.currentStream.isActive) {
                this.currentStream.close();
              }
              this.isSubmit = false;
              return;
            } else if (data.data && data.data.status === 3) {
              this.isSubmit = false;
            }

            if (data.data && data.data.answerContent) {
              // 检查是否是第一条AI回复，如果是则创建AI消息对象
              const lastMessage = this.messages[this.messages.length - 1];
              if (
                !lastMessage ||
                lastMessage.type !== "ai" ||
                lastMessage.isWelcome
              ) {
                // 添加新的AI消息对象
                this.messages.push({
                  type: "ai",
                  content: "",
                  timestamp: new Date(),
                });
              }

              this.isLoading = false;
              // 更新AI消息内容
              const currentAiMessage = this.messages[this.messages.length - 1];
              if (data.isComplete) {
                // 如果是完整响应，直接替换内容
                currentAiMessage.content = data.data.answerContent;
              } else {
                // 如果是流式响应，追加内容
                currentAiMessage.content += data.data.answerContent;
              }

              // 实时滚动到底部
              this.$nextTick(() => {
                this.scrollToBottom();
              });
            }
          },
          // onError 回调
          (error) => {
            console.error("AI对话出错:", error);
            this.isLoading = false;

            // 检查是否需要添加AI消息对象
            const lastMessage = this.messages[this.messages.length - 1];
            if (
              !lastMessage ||
              lastMessage.type !== "ai" ||
              lastMessage.isWelcome
            ) {
              // 添加新的AI消息对象
              this.messages.push({
                type: "ai",
                content: "抱歉，AI助手暂时无法回答您的问题，请稍后再试。",
                timestamp: new Date(),
              });
            } else {
              // 更新最后一条AI消息为错误信息
              lastMessage.content =
                "抱歉，AI助手暂时无法回答您的问题，请稍后再试。";
            }

            this.$message.error("AI对话出错，请重试");
          },
          // onComplete 回调
          () => {
            console.log("AI对话完成");
            this.isLoading = false;
            this.isSubmit = false;
            this.currentStream = null;

            // 滚动到底部
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        );
      } catch (error) {
        console.error("发送消息失败:", error);
        this.isLoading = false;

        // 检查是否需要添加AI消息对象
        const lastMessage = this.messages[this.messages.length - 1];
        if (
          !lastMessage ||
          lastMessage.type !== "ai" ||
          lastMessage.isWelcome
        ) {
          // 添加新的AI消息对象
          this.messages.push({
            type: "ai",
            content: "网络连接异常，请检查网络后重试。",
            timestamp: new Date(),
          });
        } else {
          // 更新最后一条AI消息为错误信息
          lastMessage.content = "网络连接异常，请检查网络后重试。";
        }

        this.$message.error("发送失败，请检查网络");
      }
    },

    formatMessage(content) {
      if (!content) return "";
      const result = marked.parse(content);
      return result;
    },

    scrollToBottom() {
      // 只在用户未手动滚动时才自动滚动
      if (this.isUserScrolling) {
        return;
      }

      const chatContent = this.$refs.chatContent;
      if (chatContent) {
        chatContent.scrollTop = chatContent.scrollHeight;
      }
    },

    autoResizeTextarea() {
      const textarea = this.$refs.messageInput;
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
    },

    addScrollListener() {
      const chatContent = this.$refs.chatContent;
      if (chatContent) {
        chatContent.addEventListener("scroll", this.handleScroll);
      }
    },

    removeScrollListener() {
      const chatContent = this.$refs.chatContent;
      if (chatContent) {
        chatContent.removeEventListener("scroll", this.handleScroll);
      }
      // 清理定时器
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
    },

    handleScroll() {
      const chatContent = this.$refs.chatContent;
      if (!chatContent) return;

      // 清除之前的定时器
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      // 检查是否在底部
      const isAtBottom = this.isAtBottom();

      if (isAtBottom) {
        // 如果在底部，重新启用自动滚动
        this.isUserScrolling = false;
      } else {
        // 如果不在底部，表示用户在手动滚动
        this.isUserScrolling = true;

        // 设置定时器，如果用户停止滚动一段时间后重新检查
        this.scrollTimer = setTimeout(() => {
          if (this.isAtBottom()) {
            this.isUserScrolling = false;
          }
        }, 1000); // 1秒后检查
      }
    },

    isAtBottom() {
      const chatContent = this.$refs.chatContent;
      if (!chatContent) return false;

      const threshold = 5; // 5px的阈值，允许小的误差
      return (
        chatContent.scrollTop + chatContent.clientHeight >=
        chatContent.scrollHeight - threshold
      );
    },

    // scrollToBottomForced() {
    //   this.isUserScrolling = false;
    //   this.scrollToBottom();
    // },
  },

  watch: {
    inputText() {
      this.$nextTick(() => {
        this.autoResizeTextarea();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-assistant-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ai-assistant__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;

  .ai-assistant__title-area {
    display: flex;
    align-items: center;
    gap: 8px;

    .ai-icon {
      width: 24px;
      height: 24px;
    }

    .ai-assistant__title {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      color: #333;
    }
  }

  .ai-assistant__close-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    &:hover {
      background-color: #f5f5f5;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }
}

.ai-assistant__content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  position: relative;
}

.message {
  display: flex;
  margin-bottom: 16px;

  &.user-message {
    flex-direction: row-reverse;

    .message-content {
      margin-right: 12px;
    }
  }

  &.ai-message {
    .message-content {
      margin-left: 12px;
    }
  }
}

.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.message-content {
  flex: 1;
  max-width: calc(100% - 60px);
}

.message-bubble {
  padding: 12px 16px;
  border-radius: 12px;
  word-wrap: break-word;

  &.user-bubble {
    background-color: #007bff;
    color: white;
    margin-left: auto;
    max-width: 70%;

    .user-text {
      line-height: 1.4;
    }
  }

  &.ai-bubble {
    background-color: white;
    color: #333;
    max-width: 85%;

    ::v-deep .welcome-text {
      &-title {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0px;
        color: #0f0f10;
        margin: 0 0 8px 0;
      }

      p {
        margin: 0 0 8px 0;
        line-height: 1.5;

        &:last-child {
          margin-bottom: 0;
        }

        &.sub-text {
          color: #666;
          font-size: 14px;
        }
      }
    }

    .plan-content {
      h4 {
        margin: 0 0 8px 0;
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }

      p {
        margin: 0 0 8px 0;
        line-height: 1.5;
        font-size: 14px;
        color: #555;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .ai-text {
      line-height: 1.5;
      font-size: 14px;

      ::v-deep br {
        line-height: 1.8;
      }
    }
  }
}

.typing-indicator {
  color: #666;
  font-style: italic;

  &::after {
    content: "...";
    animation: typing 1.5s infinite;
  }
}

@keyframes typing {
  0%,
  20% {
    content: "";
  }
  40% {
    content: ".";
  }
  60% {
    content: "..";
  }
  80%,
  100% {
    content: "...";
  }
}

.ai-assistant__footer {
  padding: 16px 20px;
}

.input-area {
  .input-container {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-radius: 10px;
    border: 1px solid #e9ecef;
    box-shadow: -5px -2px 18.4px 0px rgba(131, 185, 255, 0.23);

    &:focus-within {
      border-color: #007bff;
      background-color: white;
    }
  }

  .message-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    resize: none;
    font-size: 14px;
    line-height: 1.4;
    max-height: 120px;
    min-height: 20px;

    &::placeholder {
      color: #999;
    }

    &:disabled {
      color: #999;
      cursor: not-allowed;
    }
  }

  .send-btn {
    // background-color: #007bff;
    color: white;
    border: none;
    border-radius: 50% !important;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.2s;

    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }

    &:hover:not(:disabled) {
      // background-color: #0056b3;
      transform: translateY(-1px);
    }

    &:disabled {
      cursor: not-allowed;
      transform: none;
    }
  }
}

.chat-action-copy {
  cursor: pointer;
  // position: absolute;
  // right: 135px;
  // bottom: 0px;
  display: flex;
  align-items: right;
  justify-content: right;

  .chat-action-img {
    width: 16px;
    height: 16px;
    margin-right: 8px;

    &:hover {
      cursor: pointer;
    }
  }

  span {
    color: #7f8aa5;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    /* 100% */
  }
}

/* 滚动条样式 */
.ai-assistant__content::-webkit-scrollbar {
  width: 6px;
}

.ai-assistant__content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.ai-assistant__content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.ai-assistant__content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

// .scroll-to-bottom-btn {
//   position: absolute;
//   bottom: 20px;
//   right: 20px;
//   background: rgba(0, 123, 255, 0.9);
//   color: white;
//   padding: 8px 12px;
//   border-radius: 20px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   gap: 4px;
//   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
//   transition: all 0.2s ease;
//   backdrop-filter: blur(4px);
//   font-size: 12px;
//   z-index: 10;

//   &:hover {
//     background: rgba(0, 123, 255, 1);
//     transform: translateY(-1px);
//     box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
//   }

//   &:active {
//     transform: translateY(0);
//   }

//   svg {
//     width: 16px;
//     height: 16px;
//   }

//   span {
//     font-weight: 500;
//     white-space: nowrap;
//   }
// }
</style>
